import { AppConfig } from '@pulpo/app-config';

export const environment: AppConfig = {
  production: true,
  name: 'prod',
  apiUrl: 'https://kube.pulpo.tech/',
  adminEmail: 'tech@elpulpo.io',
  itemsPerPage: 20,
  schedulerApiUrl: 'https://batch.pulpo.tech',
  loginRoute: '/login',
  ribbonLabel: '',
};
